export const config = [];

config.stk = {
	width: 800,
	height: 600,
	margin: {
		top: 70,
		right: 30,
		bottom: 20,
		left: 30,
	},
	fontFactor: 1.5,
};

config.ilk = {
	width: 800,
	height: 600,
	margin: {
		top: 0,
		right: -20,
		bottom: 0,
		left: 0,
	},
	fontFactor: 1,
};

config.drz = {
	width: 550,
	height: 800,
	margin: {
		top: 0,
		right: 50,
		bottom: 0,
		left: 149,
	},
	fontFactor: 1.2,
};

config.krw = {
	width: 800,
	height: 600,
	margin: {
		top: -100,
		right: -100,
		bottom: 0,
		left: 25,
	},
	fontFactor: 1.2,
};

config.shw = {
	width: 800,
	height: 600,
	margin: {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
	},
	fontFactor: 1,
};

config.mam = {
	width: 800,
	height: 500,
	margin: {
		top: 100,
		right: 20,
		bottom: 50,
		left: 50,
	},
	fontFactor: 1.2,
};
